<template>
	<div class="header" v-if="shownav">
		<div class="vip">
			<a href="https://oldclass.ptestudy.com" style="color: red;">{{ $t('backtooldsys') }}</a>
		</div>
		<div class="vip" v-if="!show || vipShow">
			<router-link to="/vip"><img src="@/assets/images/vip.png" /><span>{{ $t('openvip') }}</span></router-link>
		</div>
		<div class="vip" v-else>
			<router-link to="/vip"><img src="@/assets/images/vip.png" /><span>{{ $t('validvip') }}{{ userInfo.vipExdateStr }}</span></router-link>
		</div>
		<div class="lang">
			<el-select v-model="value" @change="change" :placeholder="$t('qingxuanze')">
				<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			<img src="@/assets/images/down.png" />
		</div>
		<div class="userinfo" @click="openLogin">
			<p>{{show?userInfo.realname:$t('plogin')}}</p>
			<!--<img v-if="!show" src="@/assets/images/index_03.png" />-->
			<img v-if="show" :src="userInfo.avatar" />
		</div>
	</div>
</template>

<script>
	import protal from "@/api/protal";
	import { Message } from 'element-ui';
	import { Loading } from 'element-ui';
	export default {
		name: 'heads',
		data() {
			return {
				options: [{
					value: 'ch',
					label: '中文'
				}, {
					value: 'en',
					label: 'English'
				}],
				value: '',
				userInfo: {}
			}
		},
		computed: {
			show() {
				return this.$store.state.loginFlag;
			},
			shownav() {
				return this.$route.meta.nav;
			},
			vipShow() {
				return this.$store.state.vipShow;
			}
		},
		watch: {
			show(newVal) {
				if(newVal) {
					this.getUserInfo();
				}
			},
			'$i18n.locale': function(newVal) {
				this.value = newVal;
			},
			'$store.state.lang': function(newVal) {
				this.value = newVal;
			}
		},
		mounted() {
			if (!localStorage.getItem("lang")&&navigator.language.startsWith('ch')) {
				localStorage.setItem("lang","ch");
			}
			let l = !localStorage.getItem("lang") ? "ch" : localStorage.getItem("lang");
			this.value = l;
			
			// 确保语言选择器与当前语言同步
			this.$nextTick(() => {
				this.value = this.$i18n.locale || localStorage.getItem("lang") || "ch";
			});
			
			this.getUserInfo();
		},
		methods: {
			change(e){
				if(e != localStorage.getItem("lang")){
					localStorage.setItem("lang", e);
					this.$i18n.locale = e;
					this.$store.commit("changeLanguage", e);
				}
			},
			changeLang() {
				let locale = this.$i18n.locale;
				locale === "ch" ? (this.$i18n.locale = "en") : (this.$i18n.locale = "ch");
				localStorage.setItem("lang", this.$i18n.locale);
				this.$store.commit("changeLanguage", this.$i18n.locale);
			},
			openLogin() {
				if(!localStorage.getItem('token')) {
					let status = this.$store.state.loginShow;
					this.$store.commit("changeLogin", !status);
				} else {
					this.$router.push({
						path: '/userinfo'
					})
				}

			},
			getUserInfo() {
				protal.getUserInfo().then(res => {
					if(res.code == 200) {
						localStorage.setItem("userinfo", JSON.stringify(res.result));
						this.userInfo = res.result;
						this.$store.commit("getUserinfo");
					}
				})
			},
		},
	}
</script>

<style lang="less" scoped>
.header .lang img{
			position: absolute;
			right: 10px;
			top: 50%;
			transform: translateY(-50%);
		}
	.header .lang {
		position: relative;
		padding: 0;
		/deep/ .el-select {
			width: 80px;
			padding-left: 10px;
			position: relative;
			z-index: 9;
		}
	/deep/ .el-input__inner {
			border: none !important;
			background: none !important;
			padding: 0;
			color: #1991bf !important;
		}
		/deep/ .el-input__suffix{
			display: none;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/head.vue